import * as templates from './templates';

const createDocBtns = (docResource, selectDocBody) => {
    var docs = '';

    $.each(docResource, function (i, item) {
        docs  +=  `${templates.docR({ displayName:item.ResourceName, docId:item.ResourceID})}`;
    });
    selectDocBody.append(docs);
}


const createDayTimeOptions = (dayTimeSelector, dayTimeRange) => {
    var dayTimeOptions = '';

    $.each(dayTimeSelector, function (i, item) {
        dayTimeOptions  +=  `${templates.timeOptions({ displayName:item.DisplayName, value:item.Value })}`;
    });
    dayTimeRange.append(dayTimeOptions);
}

export {
    createDocBtns,
    createDayTimeOptions
  }